<template>
  <basic-dialog
    v-model="dialog"
    :title="data.title"
    save-button
    :max-width="data.investigation.result.matches.length===0 ? '500' : '1200'"
    :save-button-label="$i18n.t('$l.app.confirm')"
    save-button-color="primary"
    :loading-save-button="loadingSaveButton"
    @close-dialog="close()"
    @save-dialog="save()"
  >
    <basic-inv-result :investigation="data.investigation" />

    <app-api-call
      class="ma-0 pa-3 pb-0"
      :call-result="callResult"
    />

    <basic-note-hint
      v-if="data.investigation.result.matches.length!==0"
      class="mx-3"
    >
      {{ $i18n.t('$l.hint.dbMatchDialog') }}
    </basic-note-hint>

    <div
      v-if="data.investigation.result.matches.length===0"
      class="ma-0"
    >
      <v-checkbox
        v-model="selectedAsPEP"
        class="ma-2 pa-0"
        :label="$i18n.t('$l.investigation.selectSubjectAsPEP')"
        @change="markAsPep"
      />
    </div>

    <v-card-title
      v-if="data.investigation.result.matches.length!==0"
    >
      <SelectMatch :matches="data.investigation.result.matches" />
    </v-card-title>
  </basic-dialog>
</template>

<script>
import SelectMatch from './../caseResult/SelectMatch.vue'

export default {
  name: 'PoliticallyExponedPersonDialog',
  components: {
    SelectMatch
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dialog: true,
      selectedAsPEP: this.data.investigation.result.selectedAsPEP,
      loadingSaveButton: false,
      callResult: { finished: true, error: null, info: null },
      storedResult: {}
    }
  },
  computed: {
    currentCase () {
      return this.$store.getters.getCurrentCase
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  mounted () {
    this.storedResult = JSON.parse(JSON.stringify(this.data.investigation.result))
    this.data.investigation.result.matchesUpdated = Date.now()
  },
  methods: {
    close () {
      this.data.investigation.result = this.storedResult
      this.$emit('close-dialog')
    },
    save () {
      this.data.investigation.result.selectedAsPEP = this.selectedAsPEP
      this.loadingSaveButton = true
      this.$xapi.put(`investigation/procesPEPTask?caseId=${this.currentCase.caseId}&dbs=PEP`, this.data.participant)
        .then(r => {
          this.$store.commit('SET_CURRENT_CASE', r.data)
          this.close()
        })
        .catch(e => {
          this.callResult.error = e.response.localizedMessage
        }).finally(() => {
          this.loadingSaveButton = false
        })
    },
    markAsPep (e) {
      if (e) {
        this.data.investigation.result.userDefinedRiskLevel = 2
        this.data.investigation.result.userDefinedInfo = JSON.stringify({ 'dialogInfo': '$l.dialog.PEPidentifiedByUser' })
      } else {
        this.data.investigation.result.userDefinedRiskLevel = -1
      }
    }
  }
}
</script>
